import { render, staticRenderFns } from "./Synchronization.vue?vue&type=template&id=6548cdfa&scoped=true&"
import script from "./Synchronization.vue?vue&type=script&lang=js&"
export * from "./Synchronization.vue?vue&type=script&lang=js&"
import style0 from "./Synchronization.vue?vue&type=style&index=0&id=6548cdfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6548cdfa",
  null
  
)

export default component.exports